module.exports = __webpack_public_path__ + "static/media/galerija_2022_0006.7a72fd81.jpg";